import { render, staticRenderFns } from "./productCase.vue?vue&type=template&id=c19a6ca2&scoped=true&"
import script from "./productCase.vue?vue&type=script&lang=js&"
export * from "./productCase.vue?vue&type=script&lang=js&"
import style0 from "./productCase.vue?vue&type=style&index=0&id=c19a6ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19a6ca2",
  null
  
)

export default component.exports